import { useEffect, useState } from 'react';
import { api } from '../../api.ts';
import { MISSION_STATUS_LABELS } from '../../format.ts';

interface Stats {
  usersByRole: { role: string; count: number }[];
  organizationsCount: number;
  missionsByStatus: { status: string; count: number }[];
}

export const ROLE_LABELS: Record<string, string> = {
  SUPER_ADMIN: 'Super admins',
  ADMIN_SUPPORT: 'Admins support',
  ORG_OWNER: 'Propriétaires établissement',
  ORG_MANAGER: 'Managers établissement',
  EXTRA: 'Extras',
  APPORTEUR: 'Apporteurs d’affaires',
};

export function AdminDashboard() {
  const [stats, setStats] = useState<Stats | null>(null);

  useEffect(() => {
    api.get<Stats>('/admin/stats').then(setStats);
  }, []);

  if (!stats) return <div className="empty-state">Chargement…</div>;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
      <section>
        <div style={{ fontSize: 14, fontWeight: 800, marginBottom: 10 }}>Utilisateurs</div>
        <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
          {stats.usersByRole.map((r) => (
            <div key={r.role} className="card stat-card" style={{ minWidth: 150 }}>
              <div className="stat-value">{r.count}</div>
              <div className="stat-label">{ROLE_LABELS[r.role] ?? r.role}</div>
            </div>
          ))}
        </div>
      </section>

      <section>
        <div style={{ fontSize: 14, fontWeight: 800, marginBottom: 10 }}>Établissements</div>
        <div className="card stat-card" style={{ maxWidth: 170 }}>
          <div className="stat-value">{stats.organizationsCount}</div>
          <div className="stat-label">Organisations</div>
        </div>
      </section>

      <section>
        <div style={{ fontSize: 14, fontWeight: 800, marginBottom: 10 }}>Missions par statut</div>
        {stats.missionsByStatus.length === 0 && <div className="empty-state">Aucune mission créée pour l'instant.</div>}
        <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
          {stats.missionsByStatus.map((m) => (
            <div key={m.status} className="card stat-card" style={{ minWidth: 150 }}>
              <div className="stat-value">{m.count}</div>
              <div className="stat-label">{MISSION_STATUS_LABELS[m.status] ?? m.status}</div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
